import { Snackbar } from "@material-ui/core";
import React, { useContext } from "react";
import DispatchContext from "../DispatchContext";
import MuiAlert from "@material-ui/lab/Alert";
// redux 
import { useSelector, useDispatch } from "react-redux"
const CustomAlert = props => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const Alert = ({ show, message, type }) => {
    const appDispatch = useContext(DispatchContext);
    const handleClose = () => {
        appDispatch({ type: "HIDE_ALERT" });
    };
    setTimeout(() => {
        handleClose()
    }, 2000);
    return (
        <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={show}
            onClose={handleClose}
        >
            <CustomAlert onClose={handleClose} severity={type ? type : ""}>
                {message}
            </CustomAlert>
        </Snackbar>
    );
};

export default Alert;
